<template>
  <div>
    <tk-hotel-filter
      :selected-filter-options="filters"
      :filter-list="filterList"
      :key-word="keyWord"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import TkHotelFilter from './TkHotelFilter'

export default {
  name: 'TkHotelFilterSidebar',
  components: {
    TkHotelFilter,
  },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    filterList: {
      type: Array,
      required: true,
    },
    keyWord: {
      type: String,
      default: '',
    },
  },
}
</script>
